// netlinking-sourcing sends a supplier's contactEmail as an array; a string (before its
// migration) is split on commas. Blanks are dropped, duplicates are kept.
export function contactEmails(value) {
	const parts = (Array.isArray(value) ? value : [value]).flatMap((part) => (part ?? "").toString().split(","));
	return parts.map((part) => part.trim()).filter((part) => part !== "");
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Emails typed as an intermediary name: all of them when every part is an email, none otherwise.
export function parseTypedEmails(value) {
	const emails = contactEmails(value);
	return emails.length > 0 && emails.every((email) => EMAIL_PATTERN.test(email)) ? emails : [];
}
